module.exports = "/img/38.522f22.webp";